/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Badge } from "antd-mobile";
import StarRatingComponent from "react-star-rating-component";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  position: relative;
  background: black;
  width: 100%;
`;

const StyledSpaceBetweenContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: black;
  opacity: 0.7;
  min-height: 15%;
  padding: 5px;
  margin-bottom: 0.1em;
`;

const StyledTitle = styled.span`
  text-align: start;
  width: 60%;
  color: white;
  font-weight: bold;
  font-size: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 3%;
`;

const StyledReviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 40%;
`;

const StyledRatingContainer = styled.div`
  font-size: 0.8em;
`;

const StyledReviewCount = styled.span`
  margin-left: 3px
  margin-right: 3%;
  color: white;
  font-size: 0.85em;
`;

class BannerItem extends Component {
  render() {
    const { itemKey, title, category, review, reviewCount, src } = this.props;

    return (
      <StyledContainer>
        {category ? (
          <Badge
            text={category}
            style={{
              top: 15,
              right: 15,
              position: "absolute",
              fontWeight: "bold",
              fontSize: "0.8em",
              minWidth: "4em",
              color: "white",
              padding: "5px 15px",
              backgroundColor: Theme.PrimaryColor,
              borderRadius: 2
            }}
          />
        ) : null}
        <img
          key={itemKey}
          src={src}
          alt={title + "-banner-image"}
          style={{
            width: "100%",
            minHeight: "5em",
            maxHeight: "30vh",
            objectFit: "cover",
            objectPosition: "center"
          }}
          onLoad={() => {
            window.dispatchEvent(new Event("resize"));
          }}
        />
        {title ? (
          <StyledSpaceBetweenContainer>
            <StyledTitle>{title}</StyledTitle>
            <StyledReviewContainer>
              <StyledRatingContainer>
                <StarRatingComponent
                  name={"bannerItemRating"}
                  editing={false}
                  starCount={5}
                  value={review}
                  starColor={Theme.PrimaryColor}
                  emptyStarColor={"lightgrey"}
                />
              </StyledRatingContainer>
              <StyledReviewCount>({reviewCount})</StyledReviewCount>
            </StyledReviewContainer>
          </StyledSpaceBetweenContainer>
        ) : null}
      </StyledContainer>
    );
  }
}

BannerItem.propTypes = {
  itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  category: PropTypes.string,
  review: PropTypes.number,
  reviewCount: PropTypes.number,
  src: PropTypes.string.isRequired
};

BannerItem.defaultProps = {
  review: 0,
  reviewCount: 0
};

export default BannerItem;



// WEBPACK FOOTER //
// ./src/components/BannerItem/index.js